import { Alert, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import routeConfig from '../../config/routeConfig';
import styles from './register-confirmation.module.scss';

interface RegisterConfirmationProps {
	confirmationMessage: string;
	prevStep: () => void;
}

const RegisterConfirmation: React.FC<RegisterConfirmationProps> = ({
	confirmationMessage,
	prevStep,
}) => {
	const history = useHistory();
	const contactEmail = 'contacto@cybersign.gt';
	return (
		<div className={styles['register-confirmation']}>
			<Alert variant="default" className={styles['alert']}>
				<Lock />
				<AlertTitle shouldEllipsisizeText={false}>
					{confirmationMessage}
				</AlertTitle>
			</Alert>
			<p className={styles.info}>
				Segun el tipo de certificado solicitado, para que este pueda ser
				aprobado enviar los siguientes documentos al correo:{' '}
				<a href={`mailto:${contactEmail}`}>{contactEmail}</a>
			</p>
			<div className={styles.table} style={{ width: '100%' }}>
				<div className={styles.row}>
					<span>Tipo de certificado</span>
					<span>Documentos</span>
				</div>
				<div className={styles.row}>
					<span>Representante legal</span>
					<span>
						<ul>
							<li>
								Acta de nombramiento de representación legal
							</li>
							<li>RTU actualizado de la persona jurídica</li>
							<li>Razón de la persona jurídica</li>
						</ul>
					</span>
				</div>
				<div className={styles.row}>
					<span>Profesional</span>
					<span>
						<ul>
							<li>Constancia de colegiado</li>
							<li>Carta vigencia de colegiado</li>
						</ul>
					</span>
				</div>
				<div className={styles.row}>
					<span>Empleado</span>
					<span>
						<ul>
							<li>
								Acta de nombramiento de representación legal
							</li>
							<li>DPI representante legal</li>
							<li>RTU actualizado de la persona jurídica</li>
							<li>Razón de la persona jurídica</li>
							<li>
								Carta de autorización de la representante legal
							</li>
						</ul>
					</span>
				</div>
				<div className={styles.row}>
					<span>Persona jurídica</span>
					<span>
						<ul>
							<li>DPI representante legal</li>
							<li>
								Acta de nombramiento de representación legal
							</li>
							<li>RTU actualizado de la persona jurídica</li>
							<li>Razón de la persona jurídica</li>
						</ul>
					</span>
				</div>
				<div className={styles.row}>
					<span>Funcionario público</span>
					<span>
						<ul>
							<li>Constancia laboral</li>
						</ul>
					</span>
				</div>
			</div>
			<div className={styles.footer}>
				<Button variant="secondary" onClick={prevStep}>
					Regresar
				</Button>
				<Button onClick={() => history.push(routeConfig.dashboard)}>
					Continuar
				</Button>
			</div>
		</div>
	);
};

export default RegisterConfirmation;
